(function () {
  'use strict';
  if (window.psDispatch) { window.psDispatch.init(document); return; }
  // NSW statewide public holidays, checked 10 September 2026:
  // https://www.nsw.gov.au/about-nsw/public-holidays
  // These dates conservatively suspend the Sydney cutoff message; they do not
  // establish the warehouse operating calendar. Never promise an exact dispatch date.
  // Bank holidays are excluded. Merchant closure dates extend this list.
  var closed = new Set(('2026-01-01,2026-01-26,2026-04-03,2026-04-04,2026-04-05,2026-04-06,2026-04-25,2026-04-27,2026-06-08,2026-10-05,2026-12-25,2026-12-26,2026-12-28,' +
    '2027-01-01,2027-01-26,2027-03-26,2027-03-27,2027-03-28,2027-03-29,2027-04-25,2027-04-26,2027-06-14,2027-10-04,2027-12-25,2027-12-26,2027-12-27,2027-12-28').split(','));
  function localParts(now) {
    var parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:'Australia/Sydney', year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(now).map(function (part) { return [part.type, part.value]; }));
    return {day: parts.year + '-' + parts.month + '-' + parts.day, seconds: Number(parts.hour)*3600 + Number(parts.minute)*60 + Number(parts.second)};
  }
  function state(now, extraDates) {
    var local = localParts(now), date = new Date(local.day + 'T12:00:00Z');
    if (local.day < '2026-01-01' || local.day > '2027-12-31') return {kind:'calendar-expired'};
    var additional = new Set((extraDates || '').split(',').map(function (value) { return value.trim(); }));
    function isOpen(day) { var key = day.toISOString().slice(0,10); return day.getUTCDay() > 0 && day.getUTCDay() < 6 && !closed.has(key) && !additional.has(key); }
    if (isOpen(date) && local.seconds < 14*3600) return {kind:'today', seconds:14*3600-local.seconds};
    return {kind:'next'};
  }
  function init(root) {
    root.querySelectorAll('[data-ps-dispatch]').forEach(function (element) {
      if (element.dataset.psDispatchReady) return;
      element.dataset.psDispatchReady = 'true';
      var target = element.querySelector('[data-ps-dispatch-text]');
      if (!target || element.dataset.policyCutoffKnown !== 'true') return;
      function update() {
        if (!element.isConnected) return;
        // This is the store's dispatch target, qualified by the visible note.
        // It must remain readable before selection and on sold-out variants;
        // selecting a variant never changes the business-day cutoff.
        var status = state(new Date(), element.dataset.closedDates);
        if (status.kind === 'today') {
          var seconds = status.seconds, timer = [Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(function (value) { return String(value).padStart(2,'0'); }).join(':');
          target.replaceChildren(document.createTextNode('Sydney time · Order in '));
          var time = document.createElement('span'); time.className = 'vdb-countdown__timer'; time.textContent = timer;
          target.append(time);
        } else if (status.kind === 'next') target.textContent = 'Sydney time · Next business day';
        else target.textContent = 'Sydney time · Business-day target';
        setTimeout(update, 1000);
      }
      update();
    });
  }
  window.psDispatch = {init:init, state:state};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
